import 'jquery';
import Bloodhound from 'Bloodhound';
import Handlebars from 'Handlebars';
import 'typeahead';
import { en as defaultI18n } from './i18n';

/**
 * An airport field including auto-suggest.
 *
 * @type {Object}
 */
const airportField = {

  /**
   * Initializes the airportField plugin.
   * @param  {Object} jQuery Under which element we want to
   *                                        track for events.
   */
  init: function() {

    // It uses the jquery boilerplate to build the plugin.
    // https://github.com/jquery-boilerplate/jquery-boilerplate
    //
    // Scroll down to the Plugin init method to get to the business logic.
    //
    // It is then made possible to fire the plugin on an DOM element like this:
    // $(yourElementSelector).airportField();

    ;(function ( $, window, document, undefined ) {

      // Create the defaults once
      var pluginName = "airportField",
          defaults = {
            i18n: defaultI18n
          };

      // The actual plugin constructor
      function Plugin ( element, options ) {
          this.element = element;
          this.settings = $.extend( {}, defaults, options );
          this._defaults = defaults;
          this._name = pluginName;
          this.init();
      }

      // Avoid Plugin.prototype conflicts
      $.extend(Plugin.prototype, {

          init: function () {

            var self = this;
            var $airportField = $(this.element);
            var airports,
                airportASTemplateSource,
                airportASTemplate;

            var tld = $('body').attr('data-tld');
            tld = tld.replace(".","_");  // co.uk should be serialized
            tld = tld.toUpperCase();  // uppercase letters are needed

            // A handy class to test for before trigger. If it's there yet do
            // not trigger the plugin again on the element.
            $airportField.addClass('hasAirportSuggestions');
            // Instantiates the Bloodhound suggestion engine for the airports.
            airports = new Bloodhound({
              datumTokenizer: function(d) {
                return d;
              },
              queryTokenizer: Bloodhound.tokenizers.whitespace,
              remote: {

                url: 'https://airport-autosuggest.flightright.net/v1/airports/'+tld+'?name=%QUERY',
                wildcard: '%QUERY',
                filter: function (airports) {
                  // Maps the remote source JSON array to a JavaScript object array
                  return $.map(airports, function (airport) {
                    return {
                      iata: airport.iata,
                      name: airport.name,
                      value: airport.name + ' (' + airport.iata + ')'
                    };
                  });
                },
                rateLimitBy : 'debounce',
                rateLimitWait : 100
              },
              limit: 20
            });

            // Initializes the Bloodhound suggestion engine for the aiports.
            airports.initialize();

            airportASTemplateSource = '<div>{{name}} (<strong>{{iata}}</strong>)</div>';
            airportASTemplate = Handlebars.compile(airportASTemplateSource);


            // Instantiates the Autosuggest UI for the airports fields.
            $airportField.typeahead({
              highlight: true,
              minLength: 1
            },
            {
              name: 'airports',
              source: airports.ttAdapter(),
              templates: {
                empty: [
                  '<span class="fw-bold  red  pd-Asm">',
                  self.settings.i18n.noResult,
                  '</span>'
                ].join('\n'),
                suggestion: function(data) {
                  return airportASTemplate(data);
                }
              }
            }).on('typeahead:selected', function (event, data, name) {
              // Sets the iata as the submit value for the airports
              $(event.target).attr('data-submit', data.iata);
              $(event.target).attr('data-city', data.name);
              $(event.target).attr('data-display', $(event.target).val());
              $(event.target).attr('data-selected', 'true');
              $(event.target).attr('data-searched', 'true');
              $(event.target).trigger('airportField:set');
            }).on('typeahead:opened', function (event) {
              // Sets selected back to false to track wheter the user did a selection
              $(event.target).attr('data-selected', 'false');
            }).on('typeahead:closed', function (event) {
              // Sets submit value back to empty
              var $target = $(event.target);
              var submit = $target.attr('data-submit');
              var display = $target.attr('data-display');
              var selected = $target.attr('data-selected');

              // If change w/o selection to not empty value (e.g manual change)
              if(selected === 'false' && display !== $target.val() && $target.val().length > 0) {
                // Puts back former display value
                $(event.target).val(display);
              }
              // If change w/o selection to empty value (e.g manual deletion)
              else if($target.val().length === 0) {
                // Resets data submit
                $(event.target).removeAttr('data-submit').removeAttr('data-selected');
              }
            });
          }


      });

      // A really lightweight plugin wrapper around the constructor,
      // preventing against multiple instantiations
      $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
          if ( !$.data( this, "plugin_" + pluginName ) ) {
            $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
          }
        });
      };

    })( jQuery, window, document );

  }


};

$(function() {

  airportField.init();

});
